module.exports = __webpack_public_path__ + "fonts/Nunito-400-cyrillic-ext1.f21ac09.woff2";